import { DateTime } from "luxon"
/**
 * Transforma horas en forma de texto de la forma: HH:MM:SS+HH o HH:MM:SS-HH a la fecha en hora local del hotel, sin cambiar el día.
 * @param timezone - Zona horaria del hotel (e.g. "America/Mexico_City")
 * @param serverDate - ISO string de la fecha actual del servidor. Evita usar DateTime.now() del navegador.
 */
export const parseTimeString = (timeString: string, timezone = "America/Mexico_City", serverDate?: string): Date => {
    const horaUTC = DateTime.fromISO(timeString, { zone: "utc" })

    const horaHotel = horaUTC.setZone(timezone)
    const hoyHotel = serverDate
        ? DateTime.fromISO(serverDate).setZone(timezone)
        : DateTime.now().setZone(timezone)

    if (horaHotel.day !== hoyHotel.day) {
        return horaHotel
            .set({
                day: hoyHotel.day,
                month: hoyHotel.month,
                year: hoyHotel.year,
            })
            .toJSDate()
    }

    return horaHotel.toJSDate()
}
